import { getThirdwebBaseUrl } from "../../../../utils/domains.js";
import { authOptions } from "../../../../wallets/types.js";
const getLoginOptionRoute = (option) => {
    if (!authOptions.includes(option)) {
        throw new Error(`Unknown auth option ${option}`);
    }
    switch (option) {
        case "wallet":
            return "siwe";
        default:
            return option;
    }
};
export const getLoginUrl = ({ authOption, client, ecosystem, mode = "popup", redirectUrl, }) => {
    if (mode === "popup" && redirectUrl) {
        throw new Error("Redirect URL is not supported for popup mode");
    }
    if (mode === "window" && !redirectUrl) {
        throw new Error("Redirect URL is required for window mode");
    }
    const route = getLoginOptionRoute(authOption);
    let baseUrl = `${getThirdwebBaseUrl("inAppWallet")}/api/2024-05-05/login/${route}?clientId=${client.clientId}`;
    if (ecosystem?.partnerId) {
        baseUrl = `${baseUrl}&ecosystemId=${ecosystem.id}&ecosystemPartnerId=${ecosystem.partnerId}`;
    }
    else if (ecosystem) {
        baseUrl = `${baseUrl}&ecosystemId=${ecosystem.id}`;
    }
    // Always append redirectUrl to the baseUrl if mode is not popup
    if (mode !== "popup") {
        const formattedRedirectUrl = new URL(redirectUrl || window.location.href);
        formattedRedirectUrl.searchParams.set("walletId", ecosystem?.id || "inApp");
        formattedRedirectUrl.searchParams.set("authProvider", authOption);
        baseUrl = `${baseUrl}&redirectUrl=${encodeURIComponent(formattedRedirectUrl.toString())}`;
    }
    return baseUrl;
};
export const getLoginCallbackUrl = ({ authOption, client, ecosystem, }) => {
    const route = getLoginOptionRoute(authOption);
    let baseUrl = `${getThirdwebBaseUrl("inAppWallet")}/api/2024-05-05/login/${route}/callback?clientId=${client.clientId}`;
    if (ecosystem?.partnerId) {
        baseUrl = `${baseUrl}&ecosystemId=${ecosystem.id}&ecosystemPartnerId=${ecosystem.partnerId}`;
    }
    else if (ecosystem) {
        baseUrl = `${baseUrl}&ecosystemId=${ecosystem.id}`;
    }
    return baseUrl;
};
//# sourceMappingURL=getLoginPath.js.map